export default __webpack_public_path__ + "static/media/480_dummy2016-lebenslaufbusiness01.78e1a1ea.png";